import {
  IRemoveDocumentTypeResponseData,
  ITipoDocumento,
  ITiposDocumentoData,
} from '@/shared/interfaces';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { erpApi } from '@/shared/axios/erp-api';
import { useUiStore } from '@/store/ui';
import { urlApiTipoDocumento } from '@/shared/constants/networking.constants';

const { get, post, put, remove } = erpApi();

export type CreateDocumentTypeProps = {
  nombre: string;
};

///* tankstack query
export const useFetcDocumentsType = (page = 1, nombre = '', page_size = 10) => {
  return useQuery({
    queryKey: ['documentsType', page, nombre],
    queryFn: async () => {
      return getDocumentsType({ page, nombre, page_size });
    },
  });
};

export const useRemoveDocumentType = () => {
  const queryClient = useQueryClient();
  const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;

  return useMutation({
    mutationFn: removeDocumentType,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documentsType'] });
    },
    onSettled: () => {
      setConfirmDialogIsOpen(false);
    },
  });
};

/// * axios
export type GetDocumentTypesParams = {
  page?: number;
  nombre?: string;
  page_size?: number;
};

export const getDocumentsType = async (params?: GetDocumentTypesParams) => {
  const { page = 1, nombre = '', page_size = 10 } = params || {};

  return get<ITiposDocumentoData>(
    `${urlApiTipoDocumento}?page=${page}&nombre=${nombre}&page_size=${page_size}`,
    true
  );
};

export const getDocumentType = async (id: number) =>
  get<ITipoDocumento>(`${urlApiTipoDocumento}${id}/`, true);

export const createDocumentType = async (data: CreateDocumentTypeProps) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<ITipoDocumento>(urlApiTipoDocumento, data, true);

  setAlert(true, res.message, res.status);
  return res;
};

export const updateDocumentType = async (
  id: number,
  data: CreateDocumentTypeProps
) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<ITipoDocumento>(
    `${urlApiTipoDocumento}${id}/`,
    data,
    true
  );

  setAlert(true, res.message, res.status);

  return res;
};

export const removeDocumentType = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;

  const res = await remove<IRemoveDocumentTypeResponseData>(
    `${urlApiTipoDocumento}${id}/`,
    true
  );

  setAlert(true, res.message, res.status);

  return res;
};
